import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import {HeaderContainer, ImageContainer} from './TermHeaderBase'

export function TermHeader() {
  const {loginPagesLogo} = usePersonalizedThemeByCompany()
  return (
    <HeaderContainer>
      <ImageContainer src={loginPagesLogo} alt='logo' onClick={() => (window.location.href = '/login')} />
    </HeaderContainer>
  )
}
